import { Pipe, PipeTransform } from '@angular/core';
import {CalendarService} from "../../calendar.service";

@Pipe({
  name: 'badgeTracker'
})
export class BadgeTrackerPipe implements PipeTransform {

  constructor(private service: CalendarService){}

  transform(tracker: any, ...args: unknown[]): string {
    return this.service.getClassByTracker(tracker);
  }
}
